import React, { useEffect, useState } from "react";
import Card from "components/Card/Card";

import {
  Text,
  Flex,
  FormControl,
  FormLabel,
  Input,
  FormErrorMessage,
  Button,
  Textarea,
  RadioGroup,
  Stack,
  SimpleGrid,
  AbsoluteCenter,
  Center,
  Editable,
  EditablePreview,
  EditableTextarea,
  NumberInput,
  NumberInputField,
  NumberIncrementStepper,
  NumberDecrementStepper,
  NumberInputStepper,
  useColorModeValue,
  useColorMode,
  Skeleton
} from "@chakra-ui/react";
import { Field, Form, Formik } from "formik";
import CustomCheckbox from "../../../components/Checkbox/CustomCheckbox";
import axios from "axios";
import apiUrl from "../../../variables/api";
import { toast } from 'react-toastify';
import ReactSelect from "react-select";
import darkStyles from "variables/darkStyles";

let initialValues = {
  peoplesOnChange: null,
  peoplesOnActiveDuty: null,
  peoplesOnSuspension: null,
  peoplesOnVacation: null,
  transferFromOneToTwo: null,
  transferFromTwoToOne: null,
  peoplesAfterCourse: null,
  peoplesComeback: null,
  peoplesQuit: null, 
  nicknameChange: null,
  complaints: null,
  praise: null,
  commanderII: "",
  sideCommanderII: "",
};

const validate = (values) => {
  const errors = {};
  const requiredFields = Object.keys(initialValues);

  requiredFields.forEach(field => {
    if (!values[field] && values[field] !== 0) {
          errors[field] = "To pole jest obowiazkowe";
      }
  });

  return errors;
}

function Page() {
  const { colorMode } = useColorMode();
  const [formData, setFormData] = useState(initialValues);
  const formikRef = React.useRef();
  const source = axios.CancelToken.source();

  const [peoples, setPeoples] = useState([]);
  useEffect(() => {
    axios
      .get(apiUrl + "/data/peoples", {
        headers: { "x-access-token": localStorage.getItem("token") },
      })
      .then((response) => {
        console.log(response.data);
        setPeoples(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);
  useEffect(() => {
    if (peoples.length > 0) {
      axios
        .get(apiUrl + "/data/changes-sum", {
          headers: { "x-access-token": localStorage.getItem("token") },
          cancelToken: source.token,
        })
        .then((response) => {
          if (response.data.length !== 0 && response.data.dataTwo) {
            console.log("przed", response.data.dataTwo);
            setFormData(response.data.dataTwo);
            response.data.dataTwo.commanderII = peoples.find(
              (person) => person.label === response.data.dataOne.commanderII
            );
            response.data.dataTwo.sideCommanderII = peoples.find(
              (person) =>
                person.label === response.data.dataOne.sideCommanderII
            );
            console.log("po", response.data.dataTwo);
            formikRef.current.resetForm({ values: response.data.dataTwo });
          }
        })
        .catch((error) => {
          if (axios.isCancel(error)) {
            console.log("Request canceled", error.message);
          } else {
            console.error(error);
            toast.error("Napotkano błąd podczas pobierania danych z API");
          }
        });

      return () => {
        source.cancel();
      };
    }
  }, [peoples]);
  const handleSubmit = (values, { setSubmitting, resetForm }) => {
      console.log('Dane formularza', values)

      setFormData(values);
      axios.post(apiUrl + '/data/change-two', values, {
          headers: {'x-access-token': localStorage.getItem('token')}
      })
          .then(response => {
              if (response.data.success) {
                  formikRef.current.setSubmitting(false)
                  return toast.success('Pomyślnie wysłano raport zmiany II')
              } else {
                formikRef.current.setSubmitting(false)
                return toast.error('Napotkano błąd podczas wysyłania raportu zmiany II')
              }
          })
          .catch(error => {
              console.error(error);
              formikRef.current.setSubmitting(false)
              toast.error('Napotkano błąd podczas połączenia z API')
          });
  };

  return (
    <Flex flexDirection="column" pt={{ base: "120px", md: "75px" }}>
      <Card minH="125px">
        <Text fontSize="2xl" fontWeight="bold">
          Zmiana II
        </Text>
        <Formik
          initialValues={initialValues}
          validate={validate}
          // validateOnChange={false}
          // validateOnBlur={false}
          onSubmit={handleSubmit}
          innerRef={formikRef}
          enableReinitialize={true}
        >
          {({ isSubmitting, formik }) => (
            <Form>
              <SimpleGrid columns={1} gap={2}>
                <Field name="peoplesOnChange">
                  {({ field, form }) => (
                    <FormControl
                      id="peoplesOnChange"
                      isRequired
                      isInvalid={
                        form.errors.peoplesOnChange &&
                        form.touched.peoplesOnChange
                      }
                    >
                      <Flex
                        direction={"row"}
                        gap={"10px"}
                        alignItems={"center"}
                        justifyContent={"left"}
                      >
                        <Text>Liczba osób na zmianie</Text>
                        <Input type="number" {...field} w={"100px"} />
                      </Flex>
                      <FormErrorMessage>
                        {form.errors.peoplesOnChange}
                      </FormErrorMessage>
                    </FormControl>
                  )}
                </Field>

                <Field name="peoplesOnActiveDuty">
                  {({ field, form }) => (
                    <FormControl
                      id="peoplesOnActiveDuty"
                      isRequired
                      isInvalid={
                        form.errors.peoplesOnActiveDuty &&
                        form.touched.peoplesOnActiveDuty
                      }
                    >
                      <Flex
                        direction={"row"}
                        gap={"10px"}
                        alignItems={"center"}
                        justifyContent={"left"}
                      >
                        <Text>Liczba osób na aktywnej słubie</Text>
                        <Input type="number" {...field} w={"100px"} />
                      </Flex>
                      <FormErrorMessage>
                        {form.errors.peoplesOnActiveDuty}
                      </FormErrorMessage>
                    </FormControl>
                  )}
                </Field>

                <Field name="peoplesOnSuspension">
                  {({ field, form }) => (
                    <FormControl
                      id="peoplesOnSuspension"
                      isRequired
                      isInvalid={
                        form.errors.peoplesOnSuspension &&
                        form.touched.peoplesOnSuspension
                      }
                    >
                      <Flex
                        direction={"row"}
                        gap={"10px"}
                        alignItems={"center"}
                        justifyContent={"left"}
                      >
                        <Text>Liczba osób na zawieszeniu</Text>
                        <Input type="number" {...field} w={"100px"} />
                      </Flex>
                      <FormErrorMessage>
                        {form.errors.peoplesOnSuspension}
                      </FormErrorMessage>
                    </FormControl>
                  )}
                </Field>

                <Field name="peoplesOnVacation">
                  {({ field, form }) => (
                    <FormControl
                      id="peoplesOnVacation"
                      isRequired
                      isInvalid={
                        form.errors.peoplesOnVacation &&
                        form.touched.peoplesOnVacation
                      }
                    >
                      <Flex
                        direction={"row"}
                        gap={"10px"}
                        alignItems={"center"}
                        justifyContent={"left"}
                      >
                        <Text>Liczba osób na urlopie</Text>
                        <Input type="number" {...field} w={"100px"} />
                      </Flex>
                      <FormErrorMessage>
                        {form.errors.peoplesOnVacation}
                      </FormErrorMessage>
                    </FormControl>
                  )}
                </Field>

                <Field name="transferFromOneToTwo">
                  {({ field, form }) => (
                    <FormControl
                      id="transferFromOneToTwo"
                      isRequired
                      isInvalid={
                        form.errors.transferFromOneToTwo &&
                        form.touched.transferFromOneToTwo
                      }
                    >
                      <Flex
                        direction={"row"}
                        gap={"10px"}
                        alignItems={"center"}
                        justifyContent={"left"}
                      >
                        <Text>
                          Liczba osób, które przeszły ze zmiany I na zmianę II
                        </Text>
                        <Input type="number" {...field} w={"100px"} />
                      </Flex>
                      <FormErrorMessage>
                        {form.errors.transferFromOneToTwo}
                      </FormErrorMessage>
                    </FormControl>
                  )}
                </Field>

                <Field name="transferFromTwoToOne">
                  {({ field, form }) => (
                    <FormControl
                      id="transferFromTwoToOne"
                      isRequired
                      isInvalid={
                        form.errors.transferFromTwoToOne &&
                        form.touched.transferFromTwoToOne
                      }
                    >
                      <Flex
                        direction={"row"}
                        gap={"10px"}
                        alignItems={"center"}
                        justifyContent={"left"}
                      >
                        <Text>
                          Liczba osób, które przeszły ze zmiany II na zmianę I
                        </Text>
                        <Input type="number" {...field} w={"100px"} />
                      </Flex>
                      <FormErrorMessage>
                        {form.errors.transferFromTwoToOne}
                      </FormErrorMessage>
                    </FormControl>
                  )}
                </Field>

                <Field name="peoplesAfterCourse">
                  {({ field, form }) => (
                    <FormControl
                      id="peoplesAfterCourse"
                      isRequired
                      isInvalid={
                        form.errors.peoplesAfterCourse &&
                        form.touched.peoplesAfterCourse
                      }
                    >
                      <Flex
                        direction={"row"}
                        gap={"10px"}
                        alignItems={"center"}
                        justifyContent={"left"}
                      >
                        <Text>
                          Liczba osób, które dołączyły po ukończonym kursie
                          podstawowym
                        </Text>
                        <Input type="number" {...field} w={"100px"} />
                      </Flex>
                      <FormErrorMessage>
                        {form.errors.peoplesAfterCourse}
                      </FormErrorMessage>
                    </FormControl>
                  )}
                </Field>

                <Field name="peoplesComeback">
                  {({ field, form }) => (
                    <FormControl
                      id="peoplesComeback"
                      isRequired
                      isInvalid={
                        form.errors.peoplesComeback &&
                        form.touched.peoplesComeback
                      }
                    >
                      <Flex
                        direction={"row"}
                        gap={"10px"}
                        alignItems={"center"}
                        justifyContent={"left"}
                      >
                        <Text>Liczba osób, które powróciły do frakcji</Text>
                        <Input type="number" {...field} w={"100px"} />
                      </Flex>
                      <FormErrorMessage>
                        {form.errors.peoplesComeback}
                      </FormErrorMessage>
                    </FormControl>
                  )}
                </Field>

                <Field name="peoplesQuit">
                  {({ field, form }) => (
                    <FormControl
                      id="peoplesQuit"
                      isRequired
                      isInvalid={
                        form.errors.peoplesQuit && form.touched.peoplesQuit
                      }
                    >
                      <Flex
                        direction={"row"}
                        gap={"10px"}
                        alignItems={"center"}
                        justifyContent={"left"}
                      >
                        <Text>Liczba osób, które opuściły frakcje</Text>
                        <Input type="number" {...field} w={"100px"} />
                      </Flex>
                      <FormErrorMessage>
                        {form.errors.peoplesQuit}
                      </FormErrorMessage>
                    </FormControl>
                  )}
                </Field>

                <Field name="nicknameChange">
                  {({ field, form }) => (
                    <FormControl
                      id="nicknameChange"
                      isRequired
                      isInvalid={
                        form.errors.nicknameChange &&
                        form.touched.nicknameChange
                      }
                    >
                      <Flex
                        direction={"row"}
                        gap={"10px"}
                        alignItems={"center"}
                        justifyContent={"left"}
                      >
                        <Text>Ilość zmian nicków</Text>
                        <Input type="number" {...field} w={"100px"} />
                      </Flex>
                      <FormErrorMessage>
                        {form.errors.nicknameChange}
                      </FormErrorMessage>
                    </FormControl>
                  )}
                </Field>

                <Field name="complaints">
                  {({ field, form }) => (
                    <FormControl
                      id="complaints"
                      isRequired
                      isInvalid={
                        form.errors.complaints && form.touched.complaints
                      }
                    >
                      <Flex
                        direction={"row"}
                        gap={"10px"}
                        alignItems={"center"}
                        justifyContent={"left"}
                      >
                        <Text>Ilość skarg na pracowników</Text>
                        <Input type="number" {...field} w={"100px"} />
                      </Flex>
                      <FormErrorMessage>
                        {form.errors.complaints}
                      </FormErrorMessage>
                    </FormControl>
                  )}
                </Field>

                <Field name="praise">
                  {({ field, form }) => (
                    <FormControl
                      id="praise"
                      isRequired
                      isInvalid={form.errors.praise && form.touched.praise}
                    >
                      <Flex
                        direction={"row"}
                        gap={"10px"}
                        alignItems={"center"}
                        justifyContent={"left"}
                      >
                        <Text>Ilość pochwał na pracowników</Text>
                        <Input type="number" {...field} w={"100px"} />
                      </Flex>
                      <FormErrorMessage>{form.errors.praise}</FormErrorMessage>
                    </FormControl>
                  )}
                </Field>
                <Field name="commanderII">
                  {({ field, form }) => (
                    <FormControl
                      id="commanderII"
                      isRequired
                      isInvalid={
                        form.errors.commanderII && form.touched.commanderII
                      }
                    >
                      <Flex
                        direction={"row"}
                        gap={"10px"}
                        alignItems={"center"}
                        justifyContent={"left"}
                      >
                        <Text>Dowódca Zmiany II</Text>
                        <ReactSelect
                          {...field}
                          noOptionsMessage={() => "Brak dostępnych opcji"}
                          options={peoples}
                          isLoading={peoples.length === 0}
                          placeholder="Wybierz..."
                          styles={darkStyles()}
                          value={form.values[field.name]}
                          onChange={(selectedOptions) => {
                            form.setFieldValue(field.name, selectedOptions);
                          }}
                        />
                      </Flex>
                      <FormErrorMessage>
                        {form.errors.commanderII}
                      </FormErrorMessage>
                    </FormControl>
                  )}
                </Field>

                <Field name="sideCommanderII">
                  {({ field, form }) => (
                    <FormControl
                      id="sideCommanderII"
                      isRequired
                      isInvalid={
                        form.errors.sideCommanderII &&
                        form.touched.sideCommanderII
                      }
                    >
                      <Flex
                        direction={"row"}
                        gap={"10px"}
                        alignItems={"center"}
                        justifyContent={"left"}
                      >
                        <Text>Zastępca Dowódcy Zmiany II</Text>
                        <ReactSelect
                          {...field}
                          noOptionsMessage={() => "Brak dostępnych opcji"}
                          options={peoples}
                          isLoading={peoples.length === 0}
                          placeholder="Wybierz..."
                          styles={darkStyles()}
                          value={form.values[field.name]}
                          onChange={(selectedOptions) => {
                            form.setFieldValue(field.name, selectedOptions);
                          }}
                        />
                      </Flex>
                      <FormErrorMessage>
                        {form.errors.sideCommanderII}
                      </FormErrorMessage>
                    </FormControl>
                  )}
                </Field>
              </SimpleGrid>

              <Button
                mt={4}
                colorScheme="red"
                isLoading={isSubmitting}
                type="submit"
              >
                Wyślij
              </Button>
            </Form>
          )}
        </Formik>
      </Card>
    </Flex>
  );
}

export default Page;
